import axios from 'axios';

const Post = (path, header, data = null, timeout = 900000) => {
    const promise = new Promise((resolve, reject) => {
        axios.post(path, data, { headers: header, timeout: timeout })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
    return promise;
};

export default Post;

